export type District_Campaign_Type = {
  name_of_district: string;
  total_gaupalikas: number;
  gaupalikas_covered: number;
  total_camps_setup: number;
  start_date: Date | undefined;
  end_date: Date | undefined;
  days_covered: number;
  status: "ongoing" | "planned" | "completed";
};

export type Provice_Campaign_Type = {
  name_of_province: string;
  total_gaupalika: number;
  gaupalikas_covered: number;
  total_camps_setup: number;
  districts_covered: District_Campaign_Type[];
};
export const ProvinceCampaignData: Provice_Campaign_Type[] = [
  {
    name_of_province: "Sudurpashchim",
    total_gaupalika: 60,
    gaupalikas_covered: 23,
    total_camps_setup: 92,
    districts_covered: [
      {
        name_of_district: "Bajura",
        total_gaupalikas: 7,
        gaupalikas_covered: 3,
        total_camps_setup: 12,
        start_date: undefined,
        end_date: undefined,
        days_covered: 27,
        status: "planned",
      },
      {
        name_of_district: "Bajhang",
        total_gaupalikas: 9,
        gaupalikas_covered: 4,
        total_camps_setup: 16,
        start_date: undefined,
        end_date: undefined,
        days_covered: 36,
        status: "planned",
      },
      {
        name_of_district: "Darchula",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        days_covered: 18,
        status: "planned",
      },
      {
        name_of_district: "Baitadi",
        total_gaupalikas: 10,
        gaupalikas_covered: 4,
        total_camps_setup: 16,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 36,
      },
      {
        name_of_district: "Dadeldhura",
        total_gaupalikas: 5,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Kanchanpur",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 4,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Kailali",
        total_gaupalikas: 7,
        gaupalikas_covered: 3,
        total_camps_setup: 12,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 27,
      },
      {
        name_of_district: "Doti",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Achham",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
    ],
  },
  {
    name_of_province: "Karnali",
    total_gaupalika: 60,
    gaupalikas_covered: 18,
    total_camps_setup: 72,
    districts_covered: [
      {
        name_of_district: "Humla",
        total_gaupalikas: 7,
        gaupalikas_covered: 3,
        total_camps_setup: 12,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 27,
      },
      {
        name_of_district: "Mugu",
        total_gaupalikas: 4,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Jumla",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Dolpa",
        total_gaupalikas: 7,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Rukum West",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 4,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Jajarkot",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Kalikot",
        total_gaupalikas: 8,
        gaupalikas_covered: 3,
        total_camps_setup: 12,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 27,
      },
      {
        name_of_district: "Dailekh",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Surkhet",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 4,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
    ],
  },
  {
    name_of_province: "Gandaki",
    total_gaupalika: 56,
    gaupalikas_covered: 22,
    total_camps_setup: 88,
    districts_covered: [
      {
        name_of_district: "Baglung",
        total_gaupalikas: 4,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Myagdi",
        total_gaupalikas: 5,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Mustang",
        total_gaupalikas: 5,
        gaupalikas_covered: 1,
        total_camps_setup: 4,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Manang",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 4,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Kaski",
        total_gaupalikas: 4,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Parbat",
        total_gaupalikas: 4,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Syanja",
        total_gaupalikas: 4,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Nawalpur",
        total_gaupalikas: 4,
        gaupalikas_covered: 2,
        total_camps_setup: 8,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Tanahu",
        total_gaupalikas: 5,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Lamjung",
        total_gaupalikas: 5,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Gorkha",
        total_gaupalikas: 7,
        gaupalikas_covered: 4,
        total_camps_setup: 36,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 36,
      },
    ],
  },
  {
    name_of_province: "Bagmati",
    total_gaupalika: 47,
    gaupalikas_covered: 13,
    total_camps_setup: 117,
    districts_covered: [
      {
        name_of_district: "Dhading",
        total_gaupalikas: 9,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Lalitpur",
        total_gaupalikas: 9,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Dolakha",
        total_gaupalikas: 9,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Kavrepalanchowk",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        days_covered: 18,
        status: "planned",
      },
      {
        name_of_district: "Makawanpur",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Nuwakot",
        total_gaupalikas: 8,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Ramechhap",
        total_gaupalikas: 6,
        gaupalikas_covered: 2,
        total_camps_setup: 52,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 52,
      },
      {
        name_of_district: "Rasuwa",
        total_gaupalikas: 5,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Sinduli",
        total_gaupalikas: 7,
        gaupalikas_covered: 2,
        total_camps_setup: 52,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
    ],
  },

  {
    name_of_province: "Koshi",
    total_gaupalika: 29,
    gaupalikas_covered: 7,
    total_camps_setup: 63,
    districts_covered: [
      {
        name_of_district: "Okhaldhunga",
        total_gaupalikas: 8,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Sankhuwasabha",
        total_gaupalikas: 9,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Solukhumbu",
        total_gaupalikas: 8,
        gaupalikas_covered: 2,
        total_camps_setup: 18,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 18,
      },
      {
        name_of_district: "Terathum",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Jhapa",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Morang",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Sunsari",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Illam",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Pachthar",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Taplejung",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Dhankuta",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Bhojpur",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
      {
        name_of_district: "Khotang",
        total_gaupalikas: 4,
        gaupalikas_covered: 1,
        total_camps_setup: 9,
        start_date: undefined,
        end_date: undefined,
        status: "planned",
        days_covered: 9,
      },
    ],
  },
  // Other provinces go here, following the same structure.
];
